import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import CPF from 'gerador-validador-cpf';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as AuthActions } from 'store/ducks/auth';

import { Validate } from 'common';
import { Panel, Form, Loading } from 'components';

class RecoverPassword extends Component {
  state = {
    form: {
      username: '',
    },
    errors: {},
  };

  handleChangeUsername = username => {
    const { form, errors } = this.state;
    this.setState({ form: { ...form, username } });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { form } = this.state;

    const rules = {
      username: {
        required: true,
        cpf: true,
      },
    };

    const validate = Validate(form, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = e => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { form } = this.state;

    this.props.recoverPasswordRequest({
      username: CPF.format(form.username, 'digits'),
    });
  };

  render() {
    const { form, errors } = this.state;
    const { recover } = this.props;

    return (
      <Panel>
        <h4 className="text-uppercase font-bold mb-0 text-center">Recuperar Senha</h4>
        <h5 className="mb-0 text-muted text-center">Enviaremos um e-mail para você recuperar a senha.</h5>
        <Form className="form-horizontal m-t-20 p-20" onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Input
              name="username"
              placeholder="CPF"
              mask="cpf"
              value={form.username}
              onChange={this.handleChangeUsername}
              errors={errors.username}
              focus={1}
            />
          </Form.Group>

          <Form.Group className="m-t-40">
            <div className="row align-items-center">
              <div className="col-6">
                <Link to="/login" className="text-muted">
                  Voltar
                </Link>
              </div>

              <div className="col-6">
                <Form.Button className="btn btn-custom btn-block" type="submit" disabled={recover.loading}>
                  {recover.loading ? <Loading type="btn" size="small" text="Solicitar..." /> : 'Solicitar'}
                </Form.Button>
              </div>
            </div>
          </Form.Group>
        </Form>
      </Panel>
    );
  }
}

const mapState = state => ({
  recover: state.auth.recover,
});

const mapActions = dispatch => bindActionCreators(AuthActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(RecoverPassword);



// WEBPACK FOOTER //
// ./src/pages/Auth/RecoverPassword/index.js